import { render, staticRenderFns } from "./layout-default.vue?vue&type=template&id=5c5a2fa4&scoped=true&"
import script from "./layout-default.vue?vue&type=script&lang=js&"
export * from "./layout-default.vue?vue&type=script&lang=js&"
import style0 from "./layout-default.vue?vue&type=style&index=0&id=5c5a2fa4&prod&lang=css&"
import style1 from "./layout-default.vue?vue&type=style&index=1&id=5c5a2fa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a2fa4",
  null
  
)

export default component.exports